import React from 'react';

import LinkCopy from '@components/LinkCopy';
import useEventTracking from '@hooks/useEventTracking';
import useTeamRefreshGuid from '@hooks/useTeamRefreshGuid';
import { team_subscription_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { Team } from '@utils/backend-api/teams';

import SettingHeaderSeperator from '../SettingHeaderSeperator';
import styles from './styles.module.scss';

export default function SignupLink({ team }: { team: Team }) {
  const { trackEvent } = useEventTracking();
  const { refreshTeamGuid, isRefreshTeamGuidLoading } = useTeamRefreshGuid();

  const onClickRefresh = () => {
    if (confirm('Are you sure you want to refresh the signup link?') == true) {
      refreshTeamGuid();
      trackEvent(click({ clickTarget: ClickTarget.Button, clickText: 'Refresh signup link' }));
    }
  };

  return (
    <>
      <SettingHeaderSeperator sectionName="Team signup link" />
      <div className="TextField !mt-0 mb-48">
        <div className="mb-16 font-suisse-intl text-description-lg">
          Allow anyone with this link to sign up for The Information and be automatically added to
          my account. Each additional team member will be charged at an annual cost of $399 per year
          plus tax.
        </div>
        <LinkCopy
          clipboardLink={`${window.location.origin}${team_subscription_path(team.guid)}`}
          trackingProps={{
            'data-ahoy-name': 'Team Signup Link',
            'data-location': 'settings',
            'data-name': 'team_signup_link',
          }}
        />
        <div>
          <button
            className={styles.linkRefresh}
            onClick={onClickRefresh}
            disabled={isRefreshTeamGuidLoading}
            type="button"
            aria-label="Refresh signup link"
          >
            Refresh
          </button>
        </div>
      </div>
    </>
  );
}
